import React from "react";
import Navigation from "../components/Navigation.tsx";
import Hero from "../components/Hero.tsx";
import CaseStudies from "../components/CaseStudies.tsx";
import Services from "../components/Services.tsx";
import Process from "../components/Process.tsx";
import Technology from "../components/Technology.tsx";
import Testimonial from "../components/Testimonial.tsx";
import FAQ from "../components/FAQ.tsx";
import Contact from "../components/Contact.tsx";
import Footer from "../components/Footer.tsx";

const HomePage: React.FC = () => {
  return (
    <div className="homepage">
      <Navigation />
      <Hero />

      <Services />
      <Process />
      <Technology />
      <Testimonial />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;